var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrackingPage = function SvgTrackingPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 20a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V22a2 2 0 0 0-2-2H26zm0-2h12a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H26a4 4 0 0 1-4-4V22a4 4 0 0 1 4-4zm6 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 2a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm-1-10a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0v-2zm6 4a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2h2zm-8 0a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2h2zm2 4a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0v-2z"
  })));
};
export default SvgTrackingPage;